import "babel-polyfill";
import "jquery.cookie";
import "lazysizes";
import "lazysizes/plugins/bgset/ls.bgset.js";
import "lazysizes/plugins/respimg/ls.respimg.js";
import "magnific-popup";
import "select2";
import "select2/dist/js/i18n/es.js";
import "select2/dist/js/i18n/fr.js";
import "select2/dist/js/i18n/ja.js";
import "select2/dist/js/i18n/ko.js";
import "select2/dist/js/i18n/pt.js";
import "select2/dist/js/i18n/zh-CN.js";
import "slick-carousel";
import "./alpine";
import "./mobileMenu";
import "./plugins/dropdown.plugin";
import "./plugins/stickyElement.plugin";
import "./plugins/trackFocus";
import "./plugins/what-input";
import "./reduced-motion";
import "./sliders";

let reduceMotion = localStorage.getItem("reduceMotion");

$(function() {
    $("nav.primary").dropdown();
    $("nav.secondary").dropdown();

    // Careers Navigation Scroll Block

    let mq = window.matchMedia("(min-width: 1024px)");
    if (mq.matches) {
        $(".navigation__scroll").fix({
            startOffset: 72
        });
    } else {
        $(".navigation__scroll").fix({
            startOffset: 0
        });
    }

    // Main navigation scroll block
    // $(window).scroll(function(){
    //     if ($(this).scrollTop() > 100) {
    //         $('#mainNavigation').addClass('-static');
    //     } else {
    //         $('#mainNavigation').removeClass('-static');
    //     }
    //     if ($(this).scrollTop() > 200) {
    //         $('#mainNavigation').addClass('-fixed');
    //     } else {
    //         $('#mainNavigation').removeClass('-fixed');
    //     }
    // });

    // modals!
    $(".modal__button").magnificPopup({
        type: "inline",
        closeBtnInside: true,
        closeOnContentClick: false,

        callbacks: {
            open: function() {
                const mp = $.magnificPopup.instance;
                const trigger = $(mp.currItem.el[0]);

                trigger.attr("aria-expanded", "true");
            },

            close: function() {
                const mp = $.magnificPopup.instance;
                const trigger = $(mp.currItem.el[0]);

                trigger.attr("aria-expanded", "false");
            }
        }
    });

    // quote sliders
    $(".js-slider").slick({
        arrows: true,
        dots: true,
        autoplay: reduceMotion == "false" ? true : false,
        autoplaySpeed: 10000,
        speed: reduceMotion == "false" ? 300 : 0
    });

    let scrollSpeed = reduceMotion == "false" ? 500 : 0;

    var $root = $("html, body");
    $('a[href^="#"]')
        .not(".modal__button, .menu-toggle, .skip-content")
        .click(function() {
            $root.animate(
                {
                    scrollTop: $($.attr(this, "href")).offset().top - 200
                },
                scrollSpeed
            );
            return false;
        });

    // If we're on a different page and click a link with a hash
    if (window.location.hash) {
        $root.animate(
            {
                scrollTop: $(window.location.hash).offset().top - 200
            },
            scrollSpeed
        );
    }
});

// Alert Ribbon
jQuery(function($) {
    // Check if alert has been closed
    if ($.cookie("alert-box") === "closed") {
        // do now show the alert
        console.log("Do not show alert ribbon");
    } else {
        setTimeout(function() {
            $("#global_alert").slideDown();
        }, 2000);
    }
    // Handle the click event on the alert close button
    $("#global_alert .close").click(function(e) {
        // Do not perform default action when button is clicked
        e.preventDefault();
        $.cookie("alert-box", "closed", { path: "/" });
        $("#global_alert").slideUp();
    });
});

// cleanup Marketo Forms once ready.
const marketoCleanup = () => {
    // remove all but one of the #mktoStyleLoaded divs
    const marketoStyleDivs = document.querySelectorAll("#mktoStyleLoaded");
    if (marketoStyleDivs.length > 1) {
        [...marketoStyleDivs].forEach((el, index) => {
            if (index >= 1) {
                el.remove();
            }
        });
    }

    const duplicateIds = [
        "LblrequestedPCICertification",
        "LblrequestedSOCIICertification"
    ];

    duplicateIds.forEach(id => {
        const elements = document.querySelectorAll(`#${id}`);
        if (elements.length > 1) {
            for (let i = 0; i < elements.length; i++) {
                elements[i].id = i === 0 ? id : `${id}-${i + 1}`;
            }
        }
    });
};

const observer = new MutationObserver(function(mutations, observer) {
    marketoCleanup();
});

observer.observe(document, { childList: true, subtree: true });
